import * as React from 'react';

function SvgCompassExploreStroke(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 25.7C9.09 25.7 4.3 20.91 4.3 15 4.3 9.09 9.09 4.3 15 4.3c5.91 0 10.7 4.79 10.7 10.7 0 5.91-4.79 10.7-10.7 10.7zm0-1.4a9.3 9.3 0 100-18.6 9.3 9.3 0 000 18.6zm4.359-14.596c.599-.292 1.229.338.936.937l-3.066 6.273a.7.7 0 01-.322.322l-6.267 3.06c-.598.292-1.228-.338-.936-.936l3.06-6.267a.7.7 0 01.322-.322l6.273-3.067zm-5.442 4.22l-2.062 4.22 4.221-2.06 2.066-4.226-4.225 2.065z"
        fill="#414B56"
      />
    </svg>
  );
}

export default SvgCompassExploreStroke;
